import { IAmbraDirectToViewerResponse } from '@nkr/store/index';
import { IDonorProfileRecords, IFileUpload } from '@nkr/models/index';
import { FileDocumentType } from '@nkr/enums/document-type';
import FileUpload from '@nkr/components/file-upload';
import { RecordsTableWrapper } from '../styles';
import { Alert } from 'react-bootstrap';
import CtScanView from './ct-scan-view';

interface IProps {
    data: IDonorProfileRecords
    appendMedChart: boolean,
    files: IFileUpload[],
    isSuperAdmin: boolean,
    onViewFile: (docType: FileDocumentType) => void,
    onDownloadChecklist: (donorId: number) => void,
    onMedChartAppendToggle: (newValue: boolean) => void,
    onFileUpload: (docType: FileDocumentType, file: File) => void,
    onRemoveFile: (docType: FileDocumentType) => void,
    getAmbraLink: (donor: number) => Promise<IAmbraDirectToViewerResponse>,
    deleteCtScanAmbra: (donor: number) => void
}

const RecordsContent = (props: IProps) => {
    const handleMedChartDropped = (files: File[]) => {
        props.onFileUpload(FileDocumentType.DonorMedChart, files[0]);
    };

    const handleCtReportDropped = (files: File[]) => {
        props.onFileUpload(FileDocumentType.DonorCTReport, files[0]);
    };

    const handleRawTypingFileDropped = (files: File[]) => {
        props.onFileUpload(FileDocumentType.DonorRawTyping, files[0]);
    };

    const handleCenterAboFileDropped = (files: File[]) => {
        props.onFileUpload(FileDocumentType.DonorCTRABO, files[0]);
    };

    const setappendMedChart = (newValue: boolean) => {
        props.onMedChartAppendToggle(newValue);
    };

    const getFileData = (docType: FileDocumentType) => {
        let fileData = props.files.find(x => x.docType == docType);
        if (fileData == null) return [];

        return fileData.file;
    };

    const handleMedChartRemove = () => {
        props.onRemoveFile(FileDocumentType.DonorMedChart);
    };

    const handleCtReportRemove = () => {
        props.onRemoveFile(FileDocumentType.DonorCTReport);
    };

    const handleRawTypingFileRemove = () => {
        props.onRemoveFile(FileDocumentType.DonorRawTyping);
    };

    const handleCenterAboFileRemove = () => {
        props.onRemoveFile(FileDocumentType.DonorCTRABO);
    };

    if (props.data == null)
        return null;

    return (
        <>
            <div className='container-fluid donor-profile-section donor-records'>
                <Alert bsStyle='info' bsSize='sm'>
                    Note, only one of each type of file may be uploaded.  If you wish to upload a new attachment, please be sure the attachment is complete before uploading it.
                </Alert>

                <RecordsTableWrapper condensed striped>
                    <thead>
                        <tr>
                            <th></th>
                            <th>File Name</th>
                            <th>Date Uploaded</th>
                            <th>View</th>
                            <th>Upload</th>
                        </tr>
                    </thead>
                    <tbody>
                        {/* NKR Donor Chart */}
                        <tr>
                            <td>
                                <label className='control-label'>
                                    <div>NKR Donor Chart</div>
                                    <div style={{ paddingLeft: 10 }}>
                                        <a className='normal' onClick={() => props.onDownloadChecklist(props.data.donorId)} target='_blank'>
                                            Download Chart Template
                                        </a>
                                    </div>
                                </label>
                            </td>
                            <td>{props.data.medChartUploadPath.length > 0 ? props.data.medChartUploadPath : 'N/A'}</td>
                            <td>
                                {props.data.medChartUploadDate.length > 0 ? props.data.medChartUploadDate : 'N/A'}
                            </td>
                            <td>
                                {props.data.medChartUploadPath != '' ?
                                    <a style={{ cursor: 'pointer' }} onClick={() => props.onViewFile(FileDocumentType.DonorMedChart)}>View</a>
                                    :
                                    '--'
                                }
                            </td>
                            <td>
                                <FileUpload
                                    label='Click here to select the file or drag &amp; drop the file here...'
                                    files={getFileData(FileDocumentType.DonorMedChart)}
                                    singleUploadOnly={true}
                                    height='30px'
                                    accept={['.pdf']}
                                    onFileDropped={handleMedChartDropped}
                                    onRemoveFile={handleMedChartRemove} />

                                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', paddingRight: 20 }}>
                                    <div style={{ marginRight: 10, fontSize: 12 }}>Append this upload to the existing file?</div>
                                    <div style={{ fontSize: 12 }}>
                                        <label className='radio-inline'>
                                            <input id={'AppendMedChartYes'} name={'AppendMedChart'} type='radio' style={{ marginTop: 2 }}
                                                onClick={() => setappendMedChart(true)} checked={props.appendMedChart} />
                                            Yes
                                        </label>
                                        <label className='radio-inline'>
                                            <input id={'AppendMedChartNo'} name={'AppendMedChart'} type='radio' style={{ marginTop: 2 }}
                                                onClick={() => setappendMedChart(false)} checked={!props.appendMedChart} />
                                            No
                                        </label>
                                    </div>
                                </div>
                            </td>
                        </tr>

                        {/* Donor CT Report */}
                        <tr style={{ margin: '12px 0' }}>
                            <td>
                                <label className='control-label'>Donor CT Report</label>
                            </td>
                            <td>{props.data.ctReportUploadPath.length > 0 ? props.data.ctReportUploadPath : 'N/A'}</td>
                            <td>
                                {props.data.ctReportUploadDate.length > 0 ? props.data.ctReportUploadDate : 'N/A'}
                            </td>
                            <td>
                                {props.data.ctReportUploadPath != '' ?
                                    <a style={{ cursor: 'pointer' }} onClick={() => props.onViewFile(FileDocumentType.DonorCTReport)}>View</a>
                                    :
                                    '--'
                                }
                            </td>
                            <td>
                                <FileUpload
                                    label='Click here to select the file or drag &amp; drop the file here...'
                                    files={getFileData(FileDocumentType.DonorCTReport)}
                                    singleUploadOnly={true}
                                    height='30px'
                                    accept={['.pdf']}
                                    onFileDropped={handleCtReportDropped}
                                    onRemoveFile={handleCtReportRemove} />
                            </td>
                        </tr>

                        {/* Donor Raw Typing Results */}
                        <tr style={{ margin: '12px 0' }}>
                            <td>
                                <label className='control-label'>Donor Raw Typing Results</label>
                            </td>
                            <td>{props.data.rawTypingUploadPath.length > 0 ? props.data.rawTypingUploadPath : 'N/A'}</td>
                            <td>
                                {props.data.rawTypingUploadDate.length > 0 ? props.data.rawTypingUploadDate : 'N/A'}
                            </td>
                            <td>
                                {props.data.rawTypingUploadPath != '' ?
                                    <a style={{ cursor: 'pointer' }} onClick={() => props.onViewFile(FileDocumentType.DonorRawTyping)}>View</a>
                                    :
                                    '--'
                                }
                            </td>
                            <td>
                                <FileUpload
                                    label='Click here to select the file or drag &amp; drop the file here...'
                                    files={getFileData(FileDocumentType.DonorRawTyping)}
                                    singleUploadOnly={true}
                                    height='30px'
                                    accept={['.pdf']}
                                    onFileDropped={handleRawTypingFileDropped}
                                    onRemoveFile={handleRawTypingFileRemove} />
                            </td>
                        </tr>

                        {/* Center Abo Verification Report */}
                        <tr style={{ margin: '12px 0' }}>
                            <td>
                                <label className='control-label'>Center Abo Verification Report</label>
                            </td>
                            <td>{props.data.centerAboUploadPath.length > 0 ? props.data.centerAboUploadPath : 'N/A'}</td>
                            <td>
                                {props.data.centerAboUploadDate.length > 0 ? props.data.centerAboUploadDate : 'N/A'}
                            </td>
                            <td>
                                {props.data.centerAboUploadPath != '' ?
                                    <a style={{ cursor: 'pointer' }} onClick={() => props.onViewFile(FileDocumentType.DonorCTRABO)}>View</a>
                                    :
                                    '--'
                                }
                            </td>

                            <td>
                                <FileUpload
                                    label='Click here to select the file or drag &amp; drop the file here...'
                                    files={getFileData(FileDocumentType.DonorCTRABO)}
                                    singleUploadOnly={true}
                                    height='30px'
                                    accept={['.pdf']}
                                    onFileDropped={handleCenterAboFileDropped}
                                    onRemoveFile={handleCenterAboFileRemove} />
                            </td>
                        </tr>

                        {/* NKR 3rd Generation Tissue Typing */}
                        <tr style={{ margin: '12px 0' }}>
                            <td>
                                <label className='control-label'>NKR High Resolution Tissue Typing</label>
                            </td>
                            <td>{props.data.histogeneticsPdfTypingFile.length > 0 ? props.data.histogeneticsPdfTypingFile : 'N/A'}</td>
                            <td>{props.data.histogeneticsPdfTypingUploadDate.length > 0 ? props.data.histogeneticsPdfTypingUploadDate : 'N/A'}</td>
                            <td>
                                {props.data.histogeneticsPdfTypingFile != '' ?
                                    <a style={{ cursor: 'pointer' }} onClick={() => props.onViewFile(FileDocumentType.DonorHistoTyping)}>View</a>
                                    :
                                    '--'
                                }
                            </td>
                            <td></td>
                        </tr>

                        {/* NKR Molecular ABO Typing (Histo) */}
                        <tr style={{ margin: '12px 0' }}>
                            <td>
                                <label className='control-label'>NKR Molecular ABO Typing (Histo)</label>
                            </td>
                            <td>{props.data.histogeneticsPdfAboFile.length > 0 ? props.data.histogeneticsPdfAboFile : 'N/A'}</td>
                            <td>{props.data.histogeneticsPdfAboUploadDate.length > 0 ? props.data.histogeneticsPdfAboUploadDate : 'N/A'}</td>
                            <td>
                                {props.data.histogeneticsPdfAboFile != '' ?
                                    <a style={{ cursor: 'pointer' }} onClick={() => props.onViewFile(FileDocumentType.DonorHistoAbo)}> View </a>
                                    :
                                    '--'
                                }
                            </td>
                            <td></td>
                        </tr>

                        <tr style={{ margin: '12px 0' }}>
                            <td>
                                <label className='control-label'>Pre-Transplant Serology Reporting</label>
                            </td>
                            <td>
                                {props.data.serologyUploadPath.length > 0 ? props.data.serologyUploadPath : 'N/A'}
                            </td>
                            <td>{props.data.serologyUploadDate.length > 0 ? props.data.serologyUploadDate : 'N/A'} </td>
                            <td>
                                {props.data.serologyUploadPath != '' ?
                                    <a style={{ cursor: 'pointer' }} onClick={() => props.onViewFile(FileDocumentType.DonorSerology)}> View </a>
                                    :
                                    '--'
                                }
                            </td>
                            <td>&nbsp;</td>
                        </tr>

                        <tr style={{ margin: '12px 0' }}>
                            <td>
                                <label className='control-label'>Donor CT Scan</label>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>
                                <CtScanView
                                    donorId={props.data.donorId}
                                    donorAlias={props.data.donorAlias}
                                    hasCtScanOnline={props.data.hasCtScanOnline}
                                    isAdminLogin={props.isSuperAdmin}
                                    onOpenViewer={props.getAmbraLink}
                                    onDeleteCtScanAmbra={props.deleteCtScanAmbra}
                                />
                            </td>
                        </tr>
                    </tbody>
                </RecordsTableWrapper>
            </div>
        </>
    );
}

export default RecordsContent;